import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const categories = [
  { img: "/assets/ct-1 (1).png", name: "Chicken", link:"/chicken" },
  { img: "/assets/ct-1 (2).png", name: "Fish & Sea foods", link:"/fish&sea-foods" },
  { img: "/assets/ct-1 (3).png", name: "Mutton", link:"/mutton" },
  { img: "/assets/ct-1 (4).png", name: "Prawn", link:"/prawn" },
  // { img: "/assets/ct-1 (5).png", name: "Combos", link:"/combos" },
  { img: "/assets/ct-1 (6).png", name: "Frozen Foods", link:"/forzen-foods" },
];

const Categories: React.FC = () => {
  return (
    <section className="py-5">
      <Container>
        <h2 className="fw-bold mb-4 text-start ms-4">All categories</h2>
        <Row className="text-center gy-4 d-flex justify-content-center">
          {categories.map((cat, index) => (
            <Col key={index} md={2} sm={4} xs={6}>
              <div>
                <Link to={cat.link}>
                  <img
                    src={cat.img}
                    alt={cat.name}
                    className="img-fluid mb-2"
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                      borderRadius: "50%",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                  />
                </Link>
                <h6 className="fw-bold">{cat.name}</h6>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Categories;
